import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface Props {
	value: any;
	active?: boolean;
	onClick?: () => void;
}

const TabButton = styled.button<Props>`
	background-color: ${(props) =>
		props.active
			? props.theme.colors.veryLightBlue
			: props.theme.colors.darkBlue};
	border: none;
	border-top-left-radius: 3.8vmin;
	border-top-right-radius: 3.8vmin;
	box-shadow: ${(props) => (props.active ? props.theme.shadow.tab : undefined)};
	color: ${(props) =>
		props.active
			? props.theme.colors.darkBlue
			: props.theme.colors.veryLightBlue};
	cursor: pointer;
	font: ${(props) => props.theme.font.tab};
	margin-left: 1vmin;
	margin-right: 1vmin;
	overflow: hidden;
	padding: 2.6vmin 6vmin 1.4vmin;
	text-overflow: ellipsis;
	white-space: nowrap;
	&:focus {
		outline: none;
	}
`;

const Tab: FunctionComponent<Props> = (props: PropsWithChildren<Props>) => {
	const { children, ...otherProps } = props;

	return <TabButton {...otherProps}>{children}</TabButton>;
};

export default Tab;
